import { render } from "./HoneyWealthsignup.vue?vue&type=template&id=43f2cb82"
import script from "./HoneyWealthsignup.vue?vue&type=script&lang=js"
export * from "./HoneyWealthsignup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__